import * as actionTypes from "./actionTypes";
import * as types from "./types";


// Auth actions

export const SetProfileData = (data: any): types.SetProfileData => ({
    type: actionTypes.SET_PROFILE_DATA,
    data,
});

export const SetRoleClaims = (data: any): types.SetRoleClaims => ({
    type: actionTypes.SET_ROLE_CLAIMS,
    data,
});

export const SetAccessToken = (data: string): types.SetAccessToken => ({
    type: actionTypes.SET_ACCESS_TOKEN,
    data,
});

export const SetTokenClaims = (data: any): types.SetTokenClaims => ({
    type: actionTypes.SET_TOKEN_CLAIMS,
    data,
});